export function toDateString(date:Date | null):string{
	if (!date){
		return "";
	}
	if (date.getTime() == 0){
		return "";
	}
	return `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`;
}

export function toDateOnlyString(date:Date):string{
	return `${date.getFullYear()}-${(date.getMonth()+1).toString().padStart(2,"0")}-${date.getDate()}`;
}

export function humanFloat(value:number):string{
	return value.toFixed(2);
}

export function safeString(input:string):string{
	return input.replace(/[\u00A0-\u9999<>\&]/gim, function(i) {
		return "&#"+i.charCodeAt(0)+";";
	});
}

export function toPrettyDateTimeString(date:Date | null):string {

	if (!date) {
		return "";
	}

	let d = date.getDate();
	let m = date.getMonth() + 1; //Month from 0 to 11
	let y = date.getFullYear();

	let h = date.getHours();
	let i = date.getMinutes();

	if(y==1970){
		return "";
	}

	return "" + y + "-" + (m<=9 ? "0" + m : m) + "-" + (d <= 9 ? "0" + d : d) + " "  + (h <= 9 ? "0" + h : h) + ":" + (i <= 9 ? "0" + i : i);

}

export function toPrettyPlanningString(date: Date | null): string {
	if (!date) {
		return "";
	}
	if (date.getFullYear() <= 1970) {
		return "";
	}

	let now = new Date();
	let startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
	let dayDiff = Math.round((startOfDay(date) - startOfDay(now)) / (1000 * 60 * 60 * 24));

	let h = date.getHours();
	let i = date.getMinutes();
	let hasTime = h !== 0 || i !== 0;
	let timeStr = hasTime ? ` ${h <= 9 ? "0" + h : h}:${i <= 9 ? "0" + i : i}` : "";

	let label: string;
	if (dayDiff === 0) {
		label = "Vandaag";
	} else if (dayDiff === 1) {
		label = "Morgen";
	} else if (dayDiff === -1) {
		label = "Gisteren";
	} else {
		label = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
	}

	return label + timeStr;
}
